import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView
}                               from 'rewire-ui';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import addGroupDialogModel      from './AddGroupDialogModel';
import { withStyles }           from '../utility/styles';

const styles = (_theme: Theme) => ({
});

interface IAddGroupDialogProps {
}

type AddGroupDialogProps = WithStyle<ReturnType<typeof styles>, IAddGroupDialogProps>;

class AddGroupDialog extends React.PureComponent<AddGroupDialogProps> {
  constructor(props: AddGroupDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    addGroupDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={addGroupDialogModel.form} onSubmit={addGroupDialogModel.actionFn('save')}>
        <div className='content'>
          <addGroupDialogModel.form.field.areaName.Editor className='span1' />
        </div>
        <div className='content'>
          <addGroupDialogModel.form.field.groupName.Editor className='span1' />
        </div>
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: addGroupDialogModel}} DraggableResizableBoxProps={{minWidth: '275px', minHeight: '282px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IAddGroupDialogProps>(styles, AddGroupDialog);
